import {Injectable} from "@angular/core";
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from "@angular/common/http";
import {Observable, from} from "rxjs";
import {switchMap} from "rxjs/operators";
import {UserService} from "./plataforma/servicios/user.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private _user: UserService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		// Obtiene el token cacheado o lo refresca si es necesario
		return from(this._user.getToken()).pipe(
			switchMap((token) => {
				if (token) {
					request = request.clone({
						setHeaders: {
							Authorization: `Bearer ${token}`
						}
					});
				}
				return next.handle(request);
			})
		);
	}
}

